"use client"
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import TimelineItem from "./TimelineItem";
import { timelineData } from "./timelineData";

export const Timeline = ({ blok }) => {
  const containerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = () => {
    const container = containerRef.current;
    if (!container) return;

    setCanScrollLeft(container.scrollLeft > 0);
    setCanScrollRight(container.scrollLeft + container.clientWidth < container.scrollWidth);
  };

  const scroll = (direction) => {
    const container = containerRef.current;
    if (!container) return;

    const scrollAmount = direction === "left" ? -300 : 300;
    container.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  useEffect(() => {
    checkScroll();
    const container = containerRef.current;
    if (!container) return;
    container.addEventListener("scroll", checkScroll);
    return () => container.removeEventListener("scroll", checkScroll);
  }, []);

  return (
    <div style={{
      backgroundSize: "cover", // Ensure the image covers the entire section
      backgroundRepeat: "repeat", // Prevent repeating the background
    }}
      className="max-w-7xl w-full text-center lg:text-left px-4"
    >
      <div className="relative w-full py-20 overflow-x-hidden overflow-y-hidden">
        {/* Center horizontal line */}
        <div className="absolute top-1/2 left-0 w-full h-px border-t border-dotted border-[#48388980] border-2 z-0" />

        {/* Arrows */}
        {canScrollLeft && (
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-[#fefefe]  !rounded-full p-2 border-[6px] border-[#E5E4F9] shadow-[0_0_4px_1px_rgba(90,39,231,0.2)] hover:scale-150 transition-all duration-300"
            onClick={() => scroll("left")}
          >
            <ChevronLeft size={20} />
          </button>
        )}

        {canScrollRight && (
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-[#fefefe]  !rounded-full p-2 border-[6px] border-[#E5E4F9] shadow-[0_0_4px_1px_rgba(90,39,231,0.2)] hover:scale-150 transition-all duration-300"
            onClick={() => scroll("right")}
          >
            <ChevronRight size={20} />
          </button>
        )}

        {/* Scrollable items */}
        <motion.div
          ref={containerRef}
          className="relative flex overflow-x-auto overflow-y-hidden gap-32 lg:px-16 scroll-smooth  h-[500px] hide-scrollbar"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {blok?.TimelineItems?.map((item, index) => (
            <TimelineItem key={index} index={index} {...item} />
          ))}
        </motion.div>
      </div>
    </div>
  );
};
